/**
 * reload-chat.js — Header refresh parity with old reloadChat().
 *
 * STAGE: Base — always loaded (all wineries).
 *
 * Old main.js reloadChat():
 *   1. Clear transcript
 *   2. Show white overlay + spinner (~1s)
 *   3. Re-seed welcome + guided prompts
 *   4. Keep session (soft reset — not clearChatHistory)
 *
 * EVENTS:
 *   in:  ws-chat-reload  (Header refresh button)
 *   out: ws-chat-typing { active: false }, clearMessages → ws-messages-cleared
 */

import {
  on,
  emit,
  clearMessages,
  updateChatState,
} from "../../core/state.js";
import { closeWineDrawer } from "./wine-drawer.js";

const OVERLAY_MS = 1000;

let panelEl = null;
let started = false;

function showReloadOverlay(host) {
  if (!host) return;
  host.querySelectorAll(".ws-reload-overlay").forEach((n) => n.remove());
  const overlay = document.createElement("div");
  overlay.className = "ws-reload-overlay";
  overlay.setAttribute("aria-hidden", "true");
  host.appendChild(overlay);
  setTimeout(() => {
    overlay.remove();
  }, OVERLAY_MS);
}

function runReload() {
  // Stop any in-flight reply / typing indicator.
  updateChatState({ isStreaming: false });
  emit("ws-chat-typing", { active: false });

  // Close tasting-notes drawer if open (all tenants).
  try {
    closeWineDrawer();
  } catch {
    /* drawer may not be mounted yet */
  }

  // Old overlay-effect on chatbot-window while welcome re-seeds underneath.
  showReloadOverlay(panelEl);

  // Soft reset: clear transcript; MessageList re-seeds welcome + prompts.
  // Session id is kept (old clearUserCookies did NOT clear session_id).
  // Variants (e.g. wineengine build-box) listen on ws-messages-cleared.
  clearMessages();
}

/**
 * @param {{ panelEl?: HTMLElement | null }} [opts]
 */
export function init(opts = {}) {
  if (opts.panelEl) panelEl = opts.panelEl;
  if (started) return;
  started = true;
  on("ws-chat-reload", runReload);
}
